import { Dialog, DialogContent } from '@mui/material';
import { FC, useMemo } from 'react';
import { ScopeEnum } from 'src/domain';
import { useScope } from 'src/hooks';
import { DialogTitleWithCloseIcon } from '../DialogTitleWithCloseIcon/DialogTitleWithCloseIcon';
import { InheritanceHelpClusterCountry } from './InheritanceHelpClusterCountry';
import { InheritanceHelpStore } from './InheritanceHelpStore';

type InheritanceHelpDialogProps = {
    open: boolean;
    onClose: () => void;
};

export const InheritanceHelpDialog: FC<InheritanceHelpDialogProps> = ({ open, onClose }) => {
    const scope = useScope();

    const inheritanceHelpContent = useMemo(() => {
        switch (scope) {
            case ScopeEnum.STORE:
                return <InheritanceHelpStore />;
            case ScopeEnum.PARTNER:
            case ScopeEnum.CLUSTER:
                return <InheritanceHelpClusterCountry />;
        }
        return null;
    }, [scope]);

    return (
        <Dialog open={open} aria-labelledby="inheritance-help-dialog" onClose={onClose}>
            <DialogTitleWithCloseIcon
                id="inheritance-help-dialog"
                title="Inheritance description"
                handleClose={() => onClose()}
            />
            <DialogContent>{inheritanceHelpContent}</DialogContent>
        </Dialog>
    );
};
